import React from 'react';
import { Badge, FormGroup, Label, Input } from 'reactstrap';

const FormPassword = (props) => {
    let _displayMode = (props.displayMode === true) ? "block" : "none";
    let _className = props.className;
    return(
    <FormGroup className={_className} style={{ display: _displayMode }}>
        <Label>
            {props.labelName}
            &nbsp;
            <Badge color="danger">必須</Badge>
        </Label>
        <Input
            value={props.value}
            type="password"       
            maxLength="60" 
            onChange={props.onChange}/>
    </FormGroup>)
}

export default FormPassword;